var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.889 14.667a.889.889 0 01.889.889v2.666h2.666a.889.889 0 010 1.778H5.778A1.778 1.778 0 014 18.222v-2.666a.889.889 0 01.889-.89zm14.222 0a.889.889 0 01.883.785l.006.104v2.666a1.778 1.778 0 01-1.644 1.774l-.134.004h-2.666a.89.89 0 01-.104-1.772l.104-.006h2.666v-2.666a.889.889 0 01.89-.89zM18.222 4a1.778 1.778 0 011.774 1.644l.004.134v2.666a.89.89 0 01-1.772.104l-.006-.104V5.778h-2.666a.89.89 0 01-.104-1.772L15.556 4h2.666zM8.444 4a.889.889 0 01.104 1.772l-.104.006H5.778v2.666a.889.889 0 01-1.772.104L4 8.444V5.778a1.778 1.778 0 011.644-1.774L5.778 4h2.666z",
    fill: "currentColor"
  })));
}
export default SvgFullscreen;